export function isInsecureEnvironment() {
  return window.__kjsIsInsecureEnvironment__ || !window.isSecureContext
}

export function isDev() {
  return process.env.NODE_ENV === 'development'
}

export function isProd() {
  return process.env.NODE_ENV.includes('production')
}

export const isPrestashop = () => {
  let score = 0

  // 1. Strong signal: global object exposed by PrestaShop (1.7+ themes)
  if (window.prestashop) score += 3

  // 2. Strong signal: generator meta tag
  const generator = document
    .querySelector('meta[name="generator"]')
    ?.getAttribute('content')
    ?.toLowerCase()
  if (generator?.includes('prestashop')) score += 3

  // 3. Strong signal: default cookie naming pattern
  if (/(^|;\s*)PrestaShop-[^=]+=/.test(document.cookie)) score += 2

  // 4. Weak signal: asset URLs containing prestashop
  if (
    document.querySelector(
      'script[src*="prestashop"], link[href*="prestashop"]'
    )
  ) {
    score += 1
  }

  // 5. Weak signal: common body pattern in many PrestaShop pages
  if (
    document.querySelector(
      'body[id^="module-"], body[class*="lang-"][class*="currency-"]'
    )
  ) {
    score += 1
  }

  // Require at least one strong signal (or several weak ones)
  return score >= 3
}

export const isWooCommerce = () => {
  // 1. Global variable exposed by WooCommerce
  if (window.wc || window.woocommerce_params || window.wc_cart_fragments_params)
    return true

  // 2. Meta tag generated by WordPress/WooCommerce
  const meta = document.querySelector('meta[name="generator"]')
  if (meta?.content?.toLowerCase().includes('woocommerce')) return true

  // 3. Typical DOM elements
  if (
    document.querySelector('body.woocommerce') ||
    document.querySelector('body.woocommerce-page') ||
    document.querySelector('.woocommerce') ||
    document.querySelector('#woocommerce_checkout')
  )
    return true

  // 4. WooCommerce cookies
  if (
    document.cookie.includes('woocommerce_') ||
    document.cookie.includes('wp_woocommerce_session_')
  )
    return true

  // 5. Scripts injected by WooCommerce
  const scripts = Array.from(document.querySelectorAll('script[src]'))
  if (scripts.some(s => s.src.includes('/woocommerce/'))) return true

  return false
}

export const isMagento = () => {
  // 1. Global variable exposed by Magento
  if (window.Magento || window.MAGE_VERSION || window.mage) return true

  // 2. Specific meta tag
  const meta = document.querySelector('meta[name="generator"]')
  if (meta?.content?.toLowerCase().includes('magento')) return true

  // 3. Typical DOM elements of Magento
  if (
    document.querySelector('body.cms-index-index') ||
    document.querySelector('[data-mage-init]') ||
    document.querySelector('[data-bind]')
  )
    return true

  // 4. Magento cookies
  if (
    document.cookie.includes('mage-cache-sessid') ||
    document.cookie.includes('mage-cache-storage')
  )
    return true

  return false
}
